/* hide-parts-search.js — motobuys
   Hide product_type="Parts" from Searchanise SEARCH surfaces (results page +
   instant dropdown) WITHOUT touching the Parts collection grid (#snize_results).
   Type is read from .snize-attribute (Searchanise "Additional product field" =
   product_type). If that Searchanise field is disabled, .snize-attribute
   disappears and this stops matching. */
(function () {
  var TYPE = 'parts';
  function inCollectionGrid(el) {
    if (location.pathname.indexOf('/collections/') !== 0) return false;
    var g = document.getElementById('snize_results');
    return g && g.contains(el);
  }
  function run() {
    document.querySelectorAll('a.snize-item .snize-attribute').forEach(function (s) {
      if (s.textContent.trim().toLowerCase() !== TYPE) return;
      var card = s.closest('li.snize-product') || s.closest('a.snize-item');
      if (card && !inCollectionGrid(card) && card.style.display !== 'none')
        card.style.display = 'none';
    });
  }
  var q = false;
  function schedule() { if (q) return; q = true; requestAnimationFrame(function () { q = false; run(); }); }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', run) : run();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
